import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const RolePlayHero = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="relative pt-32 pb-24 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold mb-6 leading-tight">
            <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent">
              Traain Role-Play IQ™
            </span>
            <br />
            <span className="text-white">Powered by Traain</span>
          </h1>

          <h2 className="text-2xl md:text-3xl font-semibold text-gray-300 mb-12">
            Real conversations. Real scoring. Real revenue impact.
          </h2>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
            <Button
              size="lg"
              onClick={openCalendly}
              className="h-14 bg-blue-600 text-white hover:bg-blue-700 rounded-lg px-8 text-lg transition-all duration-200 hover:scale-105"
            >
              Schedule a Discovery Call
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>

          {/* Hero Image */}
          <div className="mt-20 relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-2 border-blue-500/30">
              <img
                src="https://customer-assets.emergentagent.com/job_ai-training-hub-11/artifacts/tirker23_Screenshot%202025-10-30%20at%204.27.27%E2%80%AFPM.png"
                alt="Traain Role-Play IQ™ Dashboard"
                className="w-full h-auto"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-950/50 to-transparent" />
              
              {/* Role Play Overlay */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
                <img
                  src="https://customer-assets.emergentagent.com/job_ai-training-hub-11/artifacts/702932kp_Role%20Play.jpg"
                  alt="AI Role Play Conversation"
                  className="w-80 h-auto rounded-xl shadow-2xl border-4 border-blue-500/50"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default RolePlayHero;
